// Parses the public menu URL (/:lang/menu/:userID?establishmentId=...)
export const getMenuContext = () => {
  const parts = window.location.pathname.split("/");
  const userID = parts[parts.length - 1];
  const establishmentID = new URLSearchParams(window.location.search).get(
    "establishmentId",
  );
  return { userID, establishmentID };
};
